import React, { useEffect, useState, useContext, use } from "react";
import "./home.css";
import { IoPersonOutline } from "react-icons/io5";
import { IoAdd } from "react-icons/io5";
// import requestImg from "../../assets/images/home/request1.svg";
// import pointsImg from "../../assets/images/home/points1.svg";
// progress bar
import PropTypes, { func } from "prop-types";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { Link, Route, useNavigate } from "react-router-dom";
import { axiosInstance } from "../../axiosInstance";
import { toast, ToastContainer } from "react-toastify";
import { useFormik } from "formik";
import { object, string } from "yup";
import Stack from "@mui/material/Stack";
import placeholderImg from "../../assets/images/listenaura/previewPlaceholder.png";
import * as yup from "yup";
import { BiSolidCoinStack } from "react-icons/bi";
import { FaPeopleLine } from "react-icons/fa6";
import { IoPeopleSharp } from "react-icons/io5";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: {
    xs: "90%",
    sm: 400,
    md: 500,
  },
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: "10px",
  py: 4,
  px: 2,
};
export function Home() {
  const [profiles, setProfiles] = useState([]);
  const navigate = useNavigate();

  const [agentName, setAgentName] = useState("Agent");
  const [requestData, setRequestData] = useState({});
  const [bankDetails, setBankDetails] = useState({});

  const [minWithDrawal, setMinWidthDrawal] = useState(null);
  const [loading, setLoading] = useState(false);

  // circular progress colors
  // Circular progress component
  function CircularProgressWithLabel({ value }) {
    // Ensure value is capped at 100 for display
    const percentage = Math.min(value, 100);

    return (
      <Box sx={{ position: "relative", display: "inline-flex" }}>
        {/* Background Circle */}
        <CircularProgress
          variant="determinate"
          value={100}
          size={90}
          thickness={4}
          sx={{
            color: "#e0e0e0", // gray background
          }}
        />

        {/* Foreground Circle (Actual Progress) */}
        <CircularProgress
          variant="determinate"
          value={percentage}
          size={90}
          thickness={4}
          sx={{
            color: " #45614c", // progress color
            position: "absolute",
            left: 0,
          }}
        />

        {/* Centered Text */}
        <Box
          sx={{
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            position: "absolute",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Typography
            variant="caption"
            component="div"
            sx={{ color: " #45614c", fontWeight: "bold", fontSize: "1rem" }}
          >
            {`${Math.round(percentage)}%`}
          </Typography>
        </Box>
      </Box>
    );
  }

  CircularProgressWithLabel.propTypes = {
    value: PropTypes.number.isRequired,
  };

  // fetch agent profile
  async function fetchAgentProfile() {
    try {
      const response = await axiosInstance.get("/agent/registration");
      if (response.data?.status === "success") {
        const data = response.data.data;
        const fullName = (data.first_name || "") + " " + (data.last_name || "");
        setAgentName(fullName.trim() || "Agent");

        if (data.user_referal_code?.user_id) {
          localStorage.setItem("user_id", data.user_referal_code.user_id);
        }
        // set requestData directly from user_referal_code
        if (data.user_referal_code) {
          setRequestData(data.user_referal_code);
        }

        setBankDetails({
          bank_name: data.bank_name,
          bank_account_number: data.bank_account_number,
          ifsc_code: data.ifsc_code,
        });
      }
    } catch (error) {
      console.log("Error fetching agent profile:", error);
    }
  }

  useEffect(() => {
    fetchAgentProfile();
  }, []);

  // working share
  function shareonWhatsapp() {
    const wholesalerApp =
      "https://play.google.com/store/apps/details?id=com.gomak.wholesaler";
    const ryderApp =
      "https://play.google.com/store/apps/details?id=com.gomak.ryder";
    const retailerApp =
      "https://play.google.com/store/apps/details?id=com.gomak.retailer";

    const promoCode = requestData?.code || "------";
    const points = requestData?.points || 0;

    const shareText = `Hi 👋,
      I'm using *Go Mak*, a B2B medicine delivery platform that ensures fast, secure, and reliable deliveries to healthcare providers.

      🚀 Mission: Revolutionize medicine delivery
      🌍 Vision: Become the leading trusted platform

      ✨ My Promo Code: ${promoCode}

      📲 Download the apps now:
      - GoMak Wholesaler App: ${wholesalerApp}
      - Ryder App: ${ryderApp}
      - Retailer App: ${retailerApp}`;

    const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(shareText)}`;
    window.open(whatsappUrl, "_blank");
  }

  const handleRedeem = () => {
    const points = requestData?.points ?? 0;

    if (points < minWithDrawal) {
      toast.info(`Minimum request points is ${minWithDrawal}`);
      return;
    }

    if (
      !bankDetails?.bank_name ||
      !bankDetails?.bank_account_number ||
      !bankDetails?.ifsc_code
    ) {
      toast.warning("Please add your bank details before redeeming!");
      navigate("/profile-edit", { state: { tab: "bankdetails" } });
      return;
    }

    navigate("/redeem");
  };

  return (
    <>
      {loading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "rgba(0, 0, 0, 0.3)",
            zIndex: 9999,
          }}
        >
          <Stack spacing={2} direction="row" alignItems="center">
            <CircularProgress size={40} sx={{ color: "#45614c" }} />
          </Stack>
        </div>
      )}
      <ToastContainer />
      <div className="homeBg">
        <div className="userContainer container">
          <div className="userData">
            <div>Welcome, {agentName}</div>
            <div>Here is a summary of your Referral account.</div>
          </div>
        </div>
        {/* points container */}
        <div className="pointsContainer container">
          <div className="pointsCard">
            <div className="pointsCardIcon">
              {/* <img src={pointsImg} /> */}
              <BiSolidCoinStack />
            </div>
            <div className="pointcart-content">
              <div>Points Earned</div>
              <div>{requestData?.points ?? "0"}</div>
              <div className="btnRedeem">
                <button onClick={handleRedeem}>Redeem</button>
              </div>
            </div>
          </div>
          <div className="pointsCard">
            <div className="pointsCardIcon">
              {/* <img src={requestImg} /> */}
             <IoPeopleSharp />
            </div>
            <div className="pointcart-content">
              <div>Share Promo Code:</div>
              <div>{requestData?.code || "---"}</div>
              <div>to increase your earned points</div>
            </div>
          </div>
          <div>
            {/* <div className="pointsCard">
              <div>
                <CircularProgressWithLabel
                  value={requestData?.user_count || 0}
                />
              </div>
              <div className="shareContainer">
                <div>
                  <span style={{ fontWeight: "bold", color: "#2B171B" }}>
                    {requestData?.user_count || "0"}
                  </span>{" "}
                  people have used
                  <span style={{ fontWeight: "bold", color: "#2B171B",paddingLeft:'5px'  }}>
                    {requestData?.code || "---"}
                  </span>
                </div>
                <div>
                  Share Promo Code:
                  <span style={{ fontWeight: "bold", color: "#2B171B",paddingLeft:'5px' }}>
                    {requestData?.code || "---"}
                  </span><br/>
                  to increase your earned points
                </div>
                <div className="shareBtn">
                  <button onClick={shareonWhatsapp}>Share on Whatsapp</button>
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </>
  );
}
